<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 65vw">
      <div class="modal-header">
        <h5 class="modal-title text-uppercase">Issue Inpatient Drugs:</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="patient-profile">
          <div class="profile-header">
            <span
              class="profile-photo"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 50px;
                height: 50px;
                font-size: 28px;
                border-radius: 50%;
                background-color: #f0f0f0;
              "
            >
              👤
            </span>
            <!-- <img
              src="https://via.placeholder.com/80"
              alt="Patient Photo"
              class="profile-photo"
            /> -->
            <div>
              <h2 class="text-uppercase">{{ patient.name }}</h2>
              <p>
                Patient ID: {{ patient.hospital_no }}
                <!-- | Primary Diagnosis: {{ patient.primary_diagnosis }} -->
              </p>
            </div>
          </div>
          <div class="profile-details">
            <div class="detail">
              <label>Ward/Bed:</label>
              <span>{{ patient.ward + "/ " + patient.bed }}</span>
            </div>
            <div class="detail">
              <label>DOB/Gender:</label>
              <span>{{ patient.dob }} ({{ patient.gender }})</span>
            </div>
            <div class="detail full-width">
              <label>Allergies/Notes:</label>
              <span class="medical-notes">{{ patient.complaints }}</span>
            </div>
          </div>
        </div>

        <hr class="section-divider" />

        <div class="issuance-section">
          <h3>Drugs to Issue</h3>
          <p class="instruction-note">
            Add the prescribed drugs and specify the **Dosage** and **Quantity**
            being issued for this timeline.
          </p>

          <div class="form-container">
            <div class="form-header-row">
              <div class="drug-col">Drug Name</div>
              <div class="dosage-col">Dosage Issued</div>
              <div class="qty-col">Quantity</div>
              <div class="action-col"></div>
            </div>

            <div
              class="form-row"
              v-for="(drug, index) in issuanceList"
              :key="drug.tempId"
            >
              <div class="drug-col">
                <!-- <input
                  type="text"
                  v-model="drug.name"
                  class="drug-input"
                  placeholder="e.g., Cefazolin"
                /> -->
                <iteminput
                  :visit_id="visit_id"
                  Store_id=""
                  :Rowid="index"
                  type="stock"
                  @itemoption-check="item_pick"
                />
              </div>
              <div class="dosage-col">
                <input
                  type="text"
                  v-model="drug.dosageIssued"
                  class="dosage-input"
                  placeholder="e.g., 1g IV"
                />
              </div>
              <div class="qty-col">
                <input
                  type="number"
                  v-model.number="drug.quantityToIssue"
                  min="1"
                  class="qty-input"
                  placeholder="quantity"
                />
              </div>
              <div class="action-col">
                <button
                  type="button"
                  class="btn btn-remove"
                  @click="removeDrug(index)"
                  :disabled="issuanceList.length === 1"
                >
                  &times;
                </button>
              </div>
            </div>

            <div class="add-row-container">
              <button type="button" class="btn btn-add" @click="addDrug">
                + Add Drug Row
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="issueDrugs"
          :disabled="!isFormValid"
        >
          Confirm and Issue Drugs ({{ totalItemsToIssue }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import iteminput from "../Inventory/components/issue_drug_input.vue";
import { JsItemName } from "../Inventory/components/jscomponents";
export default {
  name: "IssueInpatientDrugsModal",
  props: {
    patient: { type: Object, required: true },
    visit_id: { type: [String, Number], required: true },
  },
  data() {
    return {
      // Mock patient data
      patientName: "",
      dob: "",
      gender: "",
      roomNumber: "",
      medicalNotes: "---",
      // Dynamic List for issuance
      issuanceList: [],
      tempIdCounter: 0,
    };
  },
  components: {
    iteminput,
  },
  computed: {
    totalItemsToIssue() {
      // Calculate the total number of items being issued
      return this.issuanceList.reduce(
        (total, drug) => total + (drug.quantityToIssue || 0),
        0
      );
    },
    isFormValid() {
      // Ensure at least one valid drug entry has both a selected item and a valid quantity
      return this.issuanceList.some((drug) => {
        const hasValidDrug = drug.name && drug.name.trim() !== "";
        const hasValidQuantity = Number(drug.quantityToIssue) > 0;
        return hasValidDrug && hasValidQuantity;
      });
    },
  },
  methods: {
    item_pick(item, rowId) {
      const formattedName = JsItemName(
        item.brand_name,
        item.item_strength,
        item.item_name
      );

      // Find the correct row (by tempId or index)
      const index = this.issuanceList.findIndex(
        (d, i) => i === rowId || d.tempId === rowId
      );

      if (index !== -1) {
        // Directly update the object in Vue 3 (no $set)
        this.issuanceList[index] = {
          ...this.issuanceList[index],
          name: formattedName,
          drug_id: item.id,
        };
      } else {
        // If row not found, add a new one
        this.issuanceList.push({
          tempId: `drug_${++this.tempIdCounter}_${Math.random()
            .toString(36)
            .substr(2, 9)}`,
          name: formattedName,
          drug_id: item.id,
          dosageIssued: "",
          quantityToIssue: null,
        });
      }

      // Optional: add a new blank row if the last one is now filled
      // const lastRow = this.issuanceList[this.issuanceList.length - 1];
      // if (lastRow.name && lastRow.name.trim() !== "") {
      //   this.addDrug();
      // }
    },

    createNewDrugRow() {
      this.tempIdCounter++;
      return {
        tempId: `drug_${this.tempIdCounter}_${Math.random()
          .toString(36)
          .substr(2, 9)}`,
        name: "",
        drug_id: "",
        dosageIssued: "",
        quantityToIssue: null,
      };
    },
    addDrug() {
      this.issuanceList.push(this.createNewDrugRow());
    },
    removeDrug(index) {
      if (this.issuanceList.length > 1) {
        this.issuanceList.splice(index, 1);
      }
    },
    closeModal() {
      this.$emit("close-issue-modal");
    },
    async issueDrugs() {
      if (!this.isFormValid) {
        alert(
          "Please ensure at least one drug row has a name and quantity to issue."
        );
        return;
      }

      // Filter and clean up the list before sending
      const drugsToIssue = this.issuanceList
        .filter((drug) => drug.name.trim() !== "" && drug.quantityToIssue > 0)
        .map((drug) => ({
          drugName: drug.name.trim(),
          drug_id: drug.drug_id,
          dosageIssued: drug.dosageIssued.trim(),
          quantity: drug.quantityToIssue,
        }));

      if (drugsToIssue.length > 0) {
        this.$emit("issue-confirm", {
          patientId: this.patientId,
          issueList: drugsToIssue,
        });
        console.log("Issuing drugs:", drugsToIssue);

        var req_body = {
          drugs: drugsToIssue,
          visit_id: this.visit_id,
          pres_type: "in_dispensation",
        };

        const res = await generalApiRequest(
          "inpatient/issue_prescription/",
          "POST",
          req_body,
          1
        );
        if (res) {
          this.closeModal();
        } else {
          alert(
            "Unexpected Problem was encountered during this Issue Process. Please Try again Later"
          );
        }

        //
      }
    },
    loadData() {
      console.log(`Modal initialized for Patient ID: ${this.patientId}`);
    },
  },
  mounted() {
    // this.loadData();
    this.issuanceList.push(this.createNewDrugRow());
  },
};
</script>

<style scoped>
/* --- Existing Base Modal Styles (Kept from previous response) --- */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  color: #343a40;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6c757d;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.close:hover {
  color: #dc3545;
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.patient-profile {
  /* ... patient profile styles ... */
}

.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ced4da;
}

.profile-photo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-right: 15px;
  object-fit: cover;
  border: 2px solid #007bff;
}

.profile-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #343a40;
}

.profile-header p {
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.profile-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 20px;
  font-size: 0.95rem;
}

.detail {
  display: flex;
  flex-direction: column;
}

.detail label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 2px;
  font-size: 0.85rem;
}

.detail span {
  color: #343a40;
}

.full-width {
  grid-column: 1 / -1; /* Spans across all columns */
}

.medical-notes {
  color: #dc3545; /* Highlight important notes like allergies */
  font-weight: 500;
}

.section-divider {
  border: 0;
  border-top: 1px solid #e9ecef;
  margin: 1.5rem 0;
}

.btn {
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s, border-color 0.2s;
  border: 1px solid transparent;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border-color: #6c757d;
}

.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}

/* --- New Dynamic Form Styles --- */

.issuance-section h3 {
  margin-top: 0;
  color: #007bff;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.instruction-note {
  font-style: italic;
  color: #6c757d;
  margin-bottom: 15px;
  font-size: 0.9rem;
}

.form-container {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

/* Grid Layout for Rows */
.form-header-row,
.form-row {
  display: grid;
  grid-template-columns: 2fr 1.5fr 0.8fr 50px; /* Drug | Dosage | Qty | Action */
  gap: 10px;
  padding: 8px 10px;
  align-items: center;
}

.form-header-row {
  background-color: #e9ecef;
  font-weight: 700;
  color: #495057;
  font-size: 0.9rem;
  padding: 12px 10px;
  border-bottom: 1px solid #dee2e6;
}

.form-row {
  background-color: #fff;
  border-bottom: 1px solid #f8f9fa;
}

.form-row:nth-child(even) {
  background-color: #f8f9fa;
}

/* Input Styling */
.drug-input,
.dosage-input,
.qty-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 0.9rem;
}

.qty-input {
  text-align: center;
}

.drug-input:focus,
.dosage-input:focus,
.qty-input:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
}

/* Remove Button */
.btn-remove {
  background: #dc3545;
  color: white;
  border: none;
  padding: 4px 8px;
  font-size: 1.1rem;
  line-height: 1;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-remove:hover:not(:disabled) {
  background: #c82333;
}

.btn-remove:disabled {
  background: #e9ecef;
  color: #adb5bd;
  cursor: not-allowed;
}

/* Add Button */
.add-row-container {
  padding: 10px;
  border-top: 1px solid #dee2e6;
  text-align: center;
  background-color: #f1f3f5;
}

.btn-add {
  background: #28a745;
  color: white;
  border-color: #28a745;
  padding: 6px 15px;
  font-size: 0.9rem;
}

.btn-add:hover {
  background: #1e7e34;
  border-color: #1c7430;
}
</style>
